<dx-popup
  id="dialog-selection-produit-complementaire"
  width="auto"
  height="auto"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'produit-complementaire-selection-popup' }"
  (onShowing)="onShowing()"
  (onHiding)="onHiding()"
  [(visible)]="visible">

  <div *dxTemplate="let _ of 'title'" class="produit-complementaire-selection-header">
    <div>
      <yo-icon icon="apple-alt"></yo-icon> <strong> Choisir des produits complémentaires</strong>
    </div>

    <div class="produit-complementaire-selection-header-actions">
      <yo-button
        iconClass="fas fa-check"
        tooltip="Valider la sélection"
        [theme]="ButtonThemeEnum.VALIDATE"
        (onClick)="valider()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Annuler"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="fermer()">
      </yo-button>
    </div>
  </div>

  <section class="produit-complementaire-selection-content">
    <div class="produit-complementaire-selection-barre-outils">
      <dx-text-box
        mode="search"
        placeholder="Rechercher un produit ou un code"
        valueChangeEvent="change"
        [width]="300"
        (onValueChanged)="onSearchChanged($event)">
      </dx-text-box>
      <span class="produit-complementaire-compteur">{{ currentIdList().length }} sélectionné(s) sur {{ catalogueTotal() }}</span>
    </div>

    <dx-data-grid
      class="produit-complementaire-selection-grid"
      [dataSource]="catalogueList()"
      keyExpr="id"
      [showBorders]="true"
      [showRowLines]="true"
      [hoverStateEnabled]="true"
      [selectedRowKeys]="currentIdList()"
      (onSelectionChanged)="onSelectionChanged($event)"
      height="100%"
      noDataText="Aucun produit complémentaire disponible">

      <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
      <dxo-sorting mode="single" showSortIndexes="false"></dxo-sorting>
      <dxo-paging [enabled]="false"></dxo-paging>

      <dxi-column dataField="code" caption="Code" [width]="120" [allowSorting]="true"></dxi-column>

      <dxi-column dataField="libelle" caption="Produit décliné"
                  [allowSorting]="true"
                  sortOrder="asc"
                  [calculateCellValue]="paramSvc.getProduitLibelle"
                  cellTemplate="produitCellTemplate">
      </dxi-column>

      <div *dxTemplate="let cell of 'produitCellTemplate'" class="produit-complementaire-selection-cell" [title]="paramSvc.getNatureLibelle(cell.data)">
        <yo-icon [icon]="paramSvc.getNatureIcon(cell.data)" [theme]="paramSvc.getNatureTheme(cell.data)" cssClass="mg-r-5"></yo-icon>
        <span>{{ paramSvc.getProduitLibelle(cell.data) }}</span>
      </div>
    </dx-data-grid>

    <dx-pagination
      class="produit-complementaire-selection-pager"
      [pageSize]="PAGE_SIZE"
      [itemCount]="catalogueTotal()"
      [pageIndex]="cataloguePage()"
      (pageIndexChange)="onPageIndexChange($event)"
      [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="false"
      infoText="Page {0} sur {1}">
    </dx-pagination>
  </section>
</dx-popup>
